"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = void 0;
/* eslint-disable  @typescript-eslint/no-explicit-any */

var trackEvent = exports.trackEvent = function trackEvent(_ref) {
  var _ref$category = _ref.category,
    category = _ref$category === void 0 ? 'ROICalculator' : _ref$category,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? 'ChangeInputValue_ROI' : _ref$action,
    label = _ref.label,
    value = _ref.value;
  if (window && window.ua) {
    window.ua('trackEvent', {
      category: category,
      action: action,
      label: label,
      value: value
    });
  }
};